/**
 * Tailor Loop logo — uses the real brand logo image (indigo speech bubble + sewing needle).
 * Icon-only variant uses logo-icon.png; full variant adds "Tailor Loop" text.
 */
export function Logo({ className = '', showText = true }: { className?: string; showText?: boolean }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/logo-icon.webp"
        alt="Tailor Loop"
        className="h-8 w-8 flex-shrink-0"
      />
      {showText && (
        <span className="text-xl font-bold text-indigo-600">
          Tailor Loop
        </span>
      )}
    </div>
  )
}
